import { useEffect, useState } from "react";
import { Download, X, Smartphone } from "lucide-react";

const DISMISS_KEY = "germac_pwa_dismissed_v1";

export default function PwaInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY)) return;

    // Standalone check
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (isStandalone) return;

    // iOS detection
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", handler);

    if (isIOS) {
      // iOS doesn't fire beforeinstallprompt — show manual hint after 3s
      const t = setTimeout(() => { setIosHint(true); setShow(true); }, 3000);
      return () => { clearTimeout(t); window.removeEventListener("beforeinstallprompt", handler); };
    }

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setShow(false);
  };

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setShow(false);
    localStorage.setItem(DISMISS_KEY, "1");
  };

  if (!show) return null;

  return (
    <div
      data-testid="pwa-install-prompt"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:bottom-4 sm:w-96 z-50 gm-card border-[#4CAF50]/40 shadow-2xl"
    >
      <div className="p-4 flex items-start gap-3">
        <div className="h-11 w-11 bg-white p-1 flex items-center justify-center shrink-0 rounded-sm">
          <img src="/icon-192.png" alt="GERMAC" className="h-full w-full object-contain" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-display text-base font-black uppercase tracking-tight">Installa GERMAC</div>
          {iosHint ? (
            <p className="text-xs text-zinc-400 mt-1 leading-relaxed">
              Apri il menu condivisione <Smartphone size={12} className="inline" /> e tocca <b className="text-white">"Aggiungi a Home"</b> per installare l'app.
            </p>
          ) : (
            <p className="text-xs text-zinc-400 mt-1 leading-relaxed">
              Aggiungi GERMAC alla schermata Home per accesso rapido in officina.
            </p>
          )}
          {!iosHint && (
            <button onClick={install} className="mt-3 gm-btn-primary h-9 px-4 rounded-sm text-xs flex items-center gap-2" data-testid="pwa-install-button">
              <Download size={14} /> Installa ora
            </button>
          )}
        </div>
        <button onClick={dismiss} className="text-zinc-500 hover:text-white p-1" data-testid="pwa-install-dismiss">
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
